// @flow

import React from 'react';
import type { Node as ReactNode } from 'react';
import styles from './styles.css';

export type PropTypes = {
  size?:
    | 'expanded'
    | 'large'
    | 'small'
    | 'default'
    | 'icon-default'
    | 'icon-small',
  type?: 'success' | 'secondary' | 'alert' | 'white',
  outline?: boolean,
  children: ReactNode,
  asLink?: boolean,
  href?: string,
  onClick?: (SyntheticEvent<HTMLElement>) => any,
};

const Button = (props: PropTypes) => {
  const {
    children,
    outline,
    size = 'default',
    type = 'default',
    asLink,
    href,
    ...other
  } = props;
  const classes = [];

  switch (size) {
    case 'expanded':
      classes.push(styles.sizeExpanded);
      break;
    case 'large':
      classes.push(styles.sizeLarge);
      break;
    case 'small':
      classes.push(styles.sizeSmall);
      break;
    case 'icon-default':
      classes.push(styles.sizeIconDefault);
      break;
    case 'icon-small':
      classes.push(styles.sizeIconSmall);
      break;
    default:
      classes.push(styles.sizeDefault);
      break;
  }

  switch (type) {
    case 'success':
      classes.push(styles.typeSuccess);
      break;
    case 'secondary':
      classes.push(styles.typeSecondary);
      break;
    case 'alert':
      classes.push(styles.typeAlert);
      break;
    case 'white':
      classes.push(styles.typeWhite);
      break;
    default:
      classes.push(styles.typeDefault);
      break;
  }

  if (outline) {
    classes.push(styles.outline);
  } else {
    classes.push(styles.solid);
  }

  const htmlProps = {
    ...other,
    className: classes.join(' '),
  };

  if (asLink) {
    const noLink = href == undefined || href === '';
    const local =
      typeof window !== 'undefined' &&
      window.location.href.indexOf('localhost') >= 0;
    const dev =
      process && process.env && process.env.NODE_ENV === 'development';
    if (noLink && (local || dev)) {
      // eslint-disable-next-line no-console
      console.error(
        `Warning: asLink passed to Button but href was not set
${JSON.stringify(props, null, 4)}`
      );
    }
    return (
      <a {...htmlProps} href={href}>
        {children}
      </a>
    );
  }

  return <button {...htmlProps}>{children}</button>;
};

Button.displayName = 'Button';

export default Button;



// WEBPACK FOOTER //
// ../button/src/index.js